import { render, staticRenderFns } from "./InternalUserLanding.vue?vue&type=template&id=06f77336&scoped=true"
import script from "./InternalUserLanding.vue?vue&type=script&lang=js"
export * from "./InternalUserLanding.vue?vue&type=script&lang=js"
import style0 from "./InternalUserLanding.vue?vue&type=style&index=0&id=06f77336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f77336",
  null
  
)

export default component.exports